import "../sass/project.scss";
import * as bootstrap from "bootstrap";
const { Tooltip, Popover } = bootstrap;
window.bootstrap = bootstrap;

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
  'use strict'

  const getStoredTheme = () => localStorage.getItem('theme')
  const setStoredTheme = theme => localStorage.setItem('theme', theme)

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  const setTheme = theme => {
    if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#bd-theme')

    if (!themeSwitcher) {
      return
    }

    const themeSwitcherText = document.querySelector('#bd-theme-text')
    const activeThemeIcon = document.querySelector('.theme-icon-active use')
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
    // const svgOfActiveBtn = btnToActive.querySelector('svg use').getAttribute('href')

    document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
      element.classList.remove('active')
      element.setAttribute('aria-pressed', 'false')
    })

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')
    // activeThemeIcon.setAttribute('href', svgOfActiveBtn)
    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
    themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

    if (focus) {
      themeSwitcher.focus()
    }
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-theme-value]')
      .forEach(toggle => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-bs-theme-value')
          setStoredTheme(theme)
          setTheme(theme)
          showActiveTheme(theme, true)
        })
      })
  })
})()

document.addEventListener("DOMContentLoaded", function (event) {
  // Initialize all tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );

  // Initialize all popovers
  const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]'
  );
  const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new Popover(popoverTriggerEl)
  );

  const radios = document.querySelectorAll("input[type=radio][name=stage]");
  const harvestSlider = document.getElementById("harvestPercentage");
  const harvestLabel = document.getElementById("harvestLabel");
  const profitTarget = document.getElementById("profitTarget");
  const profitTargetLabel = document.getElementById("profitTargetLabel");
  const maxLoss = document.getElementById("maxLoss");
  const maxLossLabel = document.getElementById("maxLossLabel");

  function changeHandler(event) {
    const broker = downloadModal.querySelector("#broker");
    const harvestSlider = downloadModal.querySelector("#harvestSlider");
    const profitTargetSlider = downloadModal.querySelector(
      "#profitTargetSlider"
    );
    const profitTarget = document.getElementById("profitTarget");
    const enableMaDirectionRandomizer = document.getElementById("enableMaDirectionRandomizer");
    const lowMaxRisk = document.getElementById("lowMaxRisk");

    if (this.value == "post-funded") {
      enableMaDirectionRandomizer.checked = false;

      harvestSlider.classList.remove("d-none");
      profitTargetSlider.classList.add("d-none");
    } else {
      enableMaDirectionRandomizer.checked = true;
      lowMaxRisk.checked = false;

      harvestSlider.classList.add("d-none");
      profitTargetSlider.classList.remove("d-none");
    }

    if (this.value == "challenge") {
      profitTarget.value = 10;
      maxLoss.value = 10;
    } else if (this.value == "verification") {
      profitTarget.value = 5;
      maxLoss.value = 10;
    } else if (this.value == "single-phase") {
      profitTarget.value = 10;
      maxLoss.value = 6;
    }

    profitTargetLabel.textContent = `${profitTarget.value}%`;
    maxLossLabel.textContent = `${maxLoss.value}%`;
  }

  Array.prototype.forEach.call(radios, function (radio) {
    radio.addEventListener("change", changeHandler);
  });

  // Download Modal Control
  const downloadModal = document.getElementById("downloadModal");
  if (!downloadModal) {
    return;
  }
  downloadModal.addEventListener("show.bs.modal", (event) => {
    const button = event.relatedTarget;

    // If opened programmatically (bulk mode), relatedTarget is null — skip single-strategy setup
    if (!button) return;

    const strategyId = button.getAttribute("data-bs-strategy-id");

    const modalTitle = downloadModal.querySelector(".modal-title");
    const modalBodyInput = downloadModal.querySelector(
      ".modal-body #strategyId"
    );
    const bulkModeInput = document.getElementById("bulkMode");
    const launchBtn = document.getElementById("launchStrategyBtn");

    modalBodyInput.value = strategyId;
    if (bulkModeInput) bulkModeInput.value = "false";
    if (modalTitle) modalTitle.textContent = "Strategy Files Download";
    if (launchBtn) launchBtn.classList.remove("d-none");
  });

  harvestSlider.addEventListener("input", (e) => {
    harvestLabel.textContent = `${e.target.value}%`;
  });

  profitTarget.addEventListener("input", (e) => {
    profitTargetLabel.textContent = `${e.target.value}%`;
  });

  maxLoss.addEventListener("input", (e) => {
    maxLossLabel.textContent = `${e.target.value}%`;
  });
});


function downloadFile(type) {
  const form = document.querySelector("#downloadForm");
  const formData = {};

  for (const field of form.elements) {
    if (!field.name) continue;
    if (field.type === "radio") {
      // For radio buttons, store only the selected value
      if (field.checked) {
        formData[field.name] = field.value;
      }
    } else if (field.type === "checkbox") {
      // For checkboxes, collect values of all checked boxes with the same name
      if (!formData[field.name]) formData[field.name] = false;
      if (field.checked) {
        formData[field.name] = true;
      }
    } else {
      // For other input types, directly store the value
      formData[field.name] = field.value;
    }
  }

  if (formData["stage"] === "post-funded") {
    formData["profit_target"] = formData["harvest_prc"];
    delete formData["harvest_prc"];
  }

  // --- Bulk download mode ---
  const isBulk = formData["bulk_mode"] === "true";
  if (isBulk) {
    if (type === "launcher") return; // not supported in bulk mode

    const bulkForm = document.getElementById("bulkDownloadForm");
    if (!bulkForm || !window.selectedStrategies) return;

    bulkForm.action = `/v2/download-bulk/${type}/`;
    document.getElementById("bulkStrategyIds").value =
      Array.from(window.selectedStrategies).join(",");

    // Add all settings as hidden inputs (clear previous dynamic ones first)
    bulkForm.querySelectorAll(".dynamic-input").forEach((el) => el.remove());

    for (const key in formData) {
      if (key === "strategy_id" || key === "bulk_mode" || key === "csrfmiddlewaretoken") continue;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formData[key];
      input.className = "dynamic-input";
      bulkForm.appendChild(input);
    }

    bulkForm.submit();
    return;
  }

  // --- Single strategy download (existing behavior) ---
  let url = new URL(
    `/${formData["strategy_id"]}/download/${type}/`,
    window.location.origin
  );

  if (type === "launcher") {
    url = new URL(
      `/${formData["strategy_id"]}/launch/`,
      window.location.origin
    );
  }

  // Loop for each formData key and append it to searchParams
  for (const key in formData) {
    url.searchParams.append(key, formData[key]);
  }

  window.location.assign(url);
}

window.downloadFile = downloadFile;
